import CertificationVerifiedSvg from '@components/Images/CertificationVerifiedSvg';
import { PublicCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import {
  CERTIFICATION_COLORS,
  CertificationTypeToRenderDetails,
  DEFAULT_CERTIFICATION_COLOR,
} from '../CertificationsUtils';

const CompactCertification = ({ cert }: { cert: PublicCertification }) => {
  const { t } = useTranslation();
  const color =
    CERTIFICATION_COLORS[cert.certificationType!] ||
    DEFAULT_CERTIFICATION_COLOR; // fallback color
  const renderDetails =
    CertificationTypeToRenderDetails[cert.certificationType!];

  if (!renderDetails) {
    return null; // Don't render unsupported certification types
  }

  const labelKey = renderDetails.label;

  return (
    <Box
      direction="horizontal"
      gap="3px"
      width="fit-content"
      padding="3px 6px"
      backgroundColor={color}
      style={{
        borderRadius: '1000px',
      }}
    >
      <CertificationVerifiedSvg width={18} height={18} />
      <Text size="small" style={{ color: '#000624' }}>
        {t(labelKey)}
      </Text>
    </Box>
  );
};

export default CompactCertification;
